import deepFreeze from 'deep-freeze';

export const MODEL_NAME = Object.freeze({
  SINGULAR: 'prescriptionFillTransfer',
  PLURAL: 'prescription-fill-transfers',
});

export const FIELD_NAME = Object.freeze({
  ID: 'id',
  PROCESSED: 'processed',
  LOCATION_ID: 'locationId',
  PRESCRIPTION_FILL_ID: 'prescriptionFillId',
});

export const SCHEMA = deepFreeze({
  title: MODEL_NAME.SINGULAR,
  type: 'object',
  properties: {
    [FIELD_NAME.ID]: {
      type: 'string',
    },
    [FIELD_NAME.PROCESSED]: {
      type: 'boolean',
    },
    [FIELD_NAME.LOCATION_ID]: {
      type: 'string',
    },
    [FIELD_NAME.PRESCRIPTION_FILL_ID]: {
      type: 'string',
    },
  },
  required: [
    FIELD_NAME.ID,
  ]
});
